export type RefreshApplicationEvent = { type: 'REFRESH_APPLICATION' };

export const refreshApplication = (): RefreshApplicationEvent => ({
  type: 'REFRESH_APPLICATION',
});
